import PropTypes from "prop-types";
import React from "react";

import ModalLink from "v2/components/responsive/ModalLink";
import MoveDestinationForm from "v2/components/responsive/MoveDestinationForm";

const MoveDestinationLink = (props, context) => {
  const {params: {date, id, routeId}} = context;
  return (
    <ModalLink
      form={MoveDestinationForm}
      label="Move to Another Route"
      url={`/${date}/${routeId}/${id}/move`}
      {...props} />
  );
};

MoveDestinationLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default MoveDestinationLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/MoveDestinationLink.js
 **/